import { createElement, lazy, Suspense, type ComponentProps } from 'react';
export { IconButton } from './IconButton';
export { Table } from './Table';
export { Pagination } from './Pagination';
export { CollapseSection } from './CollapseSection';
export { NestedTreeList } from './NestedTreeList';
export { Filter } from './filters';
export { InlineEditable } from './InlineEditable';
export { CopyFromModal } from './CopyFromModal';
export { OfficeCreationDrawer } from './OfficeCreationDrawer';
export { ViewMorePopover } from './ViewMorePopover';
export { CreateContact } from './CreateContact';
export { CenterSpinner, AiLoader } from './loadders';
export { CommingSoon } from './coming-soon';
export { BulkError } from './BulkError';
export { AIScorePopover } from './ai-socre';
export { Nudges } from './Nudges';
export { TextButton } from './Button';
export { CopyButton } from './CopyButton';
export { InvalidRoute } from './InvalidRoute';
// `ApplicationActions`/`CandidateActions` are deliberately NOT re-exported here.
// They pull the whole job-stage-action tree (interview manager + scheduler,
// ~700 KB gzip / 660 modules), and this barrel is imported by the top nav, so
// re-exporting them put that entire tree in the eager entry chunk for every
// user. The three consumers import them directly from './actions' instead.
// Guarded by src/app/eagerGraph.test.ts.
export { FileUpload, ViewFile } from './FileUpload';
export { ApprovalFlowSteps } from './ApprovalFlowSteps';

//typescript components
export { Popover } from './Popover';
export { Tabs } from './Tabs';
export { Drawer } from './drawer';
// `OfferInitiation`/`useOffersHelpers` are not re-exported: the OfferInitiation
// barrel drags ~430 KB gzip of offer/e-sign UI, and this barrel is on the eager
// top-nav path. Its one consumer imports the hook directly.
export { ModalWithForm, ModalWrapper } from './modal';
export { ChakraHtmlRenderer } from './ChakraHtmlRenderer';
export { Menu } from './menu';
export { EmptyResults } from './empty-results';
export { ApplicationStatus, TimeInStage } from './application';

export { HtmlRenderer } from './HtmlRenderer';
export { BulkOperationQueue } from './BulkOperationQueue';

/**
 * The top nav imports this barrel, so everything it re-exports lands in the
 * entry chunk. EmailTemplates brought the email composer and the rich-text
 * editor (tiptap) to every page. It is re-exported lazily under the same name,
 * so importers are unchanged; the composer loads with the first page that
 * renders it. Same specifier as the old static export: the circular-dependency
 * baseline is keyed on this edge.
 */
const LazyEmailTemplates = lazy(() =>
  import('./EmailTemplates').then((module) => ({
    default: module.EmailTemplates,
  }))
);
export const EmailTemplates = (
  props: ComponentProps<typeof LazyEmailTemplates>
) =>
  createElement(
    Suspense,
    { fallback: null },
    createElement(LazyEmailTemplates, props)
  );
